import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSpring, animated, easings } from "@react-spring/web";
// import { useDrag } from "@use-gesture/react";
import styles from "./PlaceBottomPanel.module.scss";

const PlaceBottomPanel = ({ children, animation = true, onExpand }) => {
  const [expanded, setExpanded] = useState(false);
  const targetHeight = expanded ? "80vh" : "50vh"; // Panel height: 80vh when expanded, 50vh by default

  // Use animation to change panel height
  const [{ height }, api] = useSpring(() => ({
    height: targetHeight,
    config: { easing: easings.easeOutSine },
    immediate: !animation,
  }));

  // Handle swipe to control height
  // const bind = useDrag(
  //   ({ last, movement: [, my], direction: [, dy] }) => {
  //     console.log("drag");
  //     if (last) {
  //       if (dy < 0) {
  //         // Swipe up - expand
  //         setExpanded(true);
  //         api.start({ height: "80vh" });
  //         onExpand?.(true); // Call onExpand with true
  //       } else {
  //         // Swipe down - collapse
  //         setExpanded(false);
  //         api.start({ height: "50vh" });
  //         onExpand?.(false); // Call onExpand with false
  //       }
  //     }
  //   },
  //   { axis: "y" },
  // );

  // const bind = useDrag(
  //   ({ last, movement: [, my], direction: [, dy] }) => {
  //     if (last) {
  //       if (dy < 0) {
  //         setExpanded(true);
  //         api.start({ height: "80vh" });
  //         onExpand?.(true);
  //       } else {
  //         setExpanded(false);
  //         api.start({ height: "50vh" });
  //         onExpand?.(false);
  //       }
  //     }
  //   },
  //   { axis: "y" },
  // );
  /*{...bind()}*/

  return (
    <animated.div
      style={{
        height,
      }}
      className={styles.panel}
    >
      {children}
    </animated.div>
  );
};

PlaceBottomPanel.propTypes = {
  children: PropTypes.node.isRequired,
  animation: PropTypes.bool,
  onExpand: PropTypes.func, // Function called when state changes
};

export default PlaceBottomPanel;
